import type { SVGProps } from 'react';

const SvgTooltipBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinejoin='round'
    />
    <path
      d='M12 9C12.55 9 13 8.55 13 8C13 7.45 12.55 7 12 7C11.45 7 11 7.45 11 8C11 8.55 11.45 9 12 9Z'
      fill='currentColor'
    />
    <path d='M12 16L12 12' stroke='currentColor' strokeWidth={2} strokeLinecap='round' />
  </svg>
);
export default SvgTooltipBd;
